import { render, staticRenderFns } from "./qixiang.vue?vue&type=template&id=56b1f904&scoped=true&"
import script from "./qixiang.vue?vue&type=script&lang=js&"
export * from "./qixiang.vue?vue&type=script&lang=js&"
import style0 from "./qixiang.vue?vue&type=style&index=0&id=56b1f904&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56b1f904",
  null
  
)

export default component.exports